import { Component, Input } from "@angular/core";

import { PageObjectList } from "src/app/models/pageobjectlist";

@Component({
  selector: "hkt-pageobjectlist",
  templateUrl: "./pageobjectlist.component.html",
  styleUrls: ["./pageobjectlist.component.scss"],
})
export class PageObjectListComponent {
  @Input("obj") obj: PageObjectList;
  @Input("mode") mode: string;

  constructor() {}
}
